"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogTrigger: function() {
        return _DialogTrigger.DialogTrigger;
    },
    renderDialogTrigger_unstable: function() {
        return _renderDialogTrigger.renderDialogTrigger_unstable;
    },
    useDialogTrigger_unstable: function() {
        return _useDialogTrigger.useDialogTrigger_unstable;
    }
});
const _DialogTrigger = require("./DialogTrigger");
const _renderDialogTrigger = require("./renderDialogTrigger");
const _useDialogTrigger = require("./useDialogTrigger");
